import Swiper from "swiper";

export function carouselSwiper() {
	document
		.querySelectorAll(
			".wp-block-query.is-style-carousel, .wp-block-query:has(.is-style-carousel)",
		)
		.forEach((block) => {
			function addClasses() {
				const slides = block.querySelectorAll(".wp-block-post");
				const postTemplate = block.querySelector(".wp-block-post-template");

				block.classList.add("swiper");
				slides.forEach((slide) => slide.classList.add("swiper-slide"));
				postTemplate.classList.add("swiper-wrapper");
			}

			function removeClasses() {
				const slides = block.querySelectorAll(".wp-block-post");
				const postTemplate = block.querySelector(".wp-block-post-template");

				block.classList.remove("swiper");
				slides.forEach((slide) => slide.classList.remove("swiper-slide"));
				postTemplate.classList.remove("swiper-wrapper");
			}

			let swiper = null;

			function evaluate() {
				if (window.innerWidth >= 600) {
					if (swiper) {
						swiper.destroy(true, true);
						swiper = null;
						removeClasses();
					}
				} else {
					if (!swiper) {
						addClasses();

						swiper = new Swiper(block, {
							loop: false,
							spaceBetween: 20,
							slidesPerView: 1.15,
						});
					}
				}
			}

			window.addEventListener("resize", evaluate);
			evaluate();
		});
}
